const ACTION = {
  SHOW_COMMON_POPUP: 'SHOW_COMMON_POPUP',
  HIDE_COMMON_POPUP: 'HIDE_COMMON_POPUP',
  SHOW_WELCOME_POPUP: 'SHOW_WELCOME_POPUP',
  HIDE_WELCOME_POPUP: 'HIDE_WELCOME_POPUP',
  SHOW_PANEL_ICON: 'SHOW_PANEL_ICON',
  HIDE_PANEL_ICON: 'HIDE_PANEL_ICON',
  SET_TOURNAMENT_DATA: 'SET_TOURNAMENT_DATA',
  SET_TOURNAMENT_PLAYERS_DATA: 'SET_TOURNAMENT_PLAYERS_DATA',
  SET_APP_CONFIGURATION: 'SET_APP_CONFIGURATION',
  SHOW_FREESPIN_WIN: 'SHOW_FREESPIN_WIN',
  HIDE_FREESPIN_WIN: 'HIDE_FREESPIN_WIN',
  SHOW_FREESPIN_FINISH: 'SHOW_FREESPIN_FINISH',
  HIDE_FREESPIN_FINISH: 'HIDE_FREESPIN_FINISH',
  SHOW_FREESPIN_WIN_OTHER_GAME: 'SHOW_FREESPIN_WIN_OTHER_GAME',
  HIDE_FREESPIN_WIN_OTHER_GAME: 'HIDE_FREESPIN_WIN_OTHER_GAME',
  SET_ACHIEVEMENT_DATA: 'SET_ACHIEVEMENT_DATA',
  SETTINGS_CORRECT_PROMO: 'SETTINGS_CORRECT_PROMO',
  CHANGE_ICONS_PROMO: 'CHANGE_ICONS_PROMO',
  SHOW_PROGRESS_BAR: 'SHOW_PROGRESS_BAR',
  HIDE_PROGRESS_BAR: 'HIDE_PROGRESS_BAR',
  SHOW_TOOLTIP: 'SHOW_TOOLTIP',
  HIDE_TOOLTIP: 'HIDE_TOOLTIP',
  SHOW_MENU: 'SHOW_MENU',
  HIDE_MENU: 'HIDE_MENU',
  CLEAR_ACHIEVEMENT: 'CLEAR_ACHIEVEMENT',
  CLEAR_TOURNAMENT: 'CLEAR_TOURNAMENT',
  SET_FREESPIN_DATA: 'SET_FREESPIN_DATA',
  SET_FREE_ROUNDS_DATA: 'SET_FREE_ROUNDS_DATA',
  SET_PIXEL_RATIO: 'SET_PIXEL_RATIO',
  SHOW_PRIZE_GAME_WIN: 'SHOW_PRIZE_GAME_WIN',
  HIDE_PRIZE_GAME_WIN: 'HIDE_PRIZE_GAME_WIN',
  SET_FREE_BETS_DATA: 'SET_FREE_BETS_DATA',
  SET_FREE_BET_SPINS_DATA: 'SET_FREE_BET_SPINS_DATA',
  SET_PANEL_ICON_COUNT_VISIBLE: 'SET_PANEL_ICON_COUNT_VISIBLE',
  SET_PROGRESS_CHECK_VISIBLE: 'SET_PROGRESS_CHECK_VISIBLE',
  SET_TAB_WELCOME_VISIBLE: 'SET_TAB_WELCOME_VISIBLE',
  SET_FREE_BET: 'SET_FREE_BET',
  SET_MESSAGE_VISIBLE: 'SET_MESSAGE_VISIBLE',
  SET_MESSAGE: 'SET_MESSAGE',

  ON_RESIZE: 'ON_RESIZE',
  REQUIRE_TOURNAMENT_PLAYERS: 'REQUIRE_TOURNAMENT_PLAYERS'
};

export { ACTION };
